import colors from '../../../../theme/foundations/colors'
import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'

export const labelNameStyle = {
    fontSize: pxToRem(13),
    margin: '0px',
    padding: '0px',
    fontWeight: '500',
    marginBottom: `${pxToRem(5)} !important`,
    fontFamily: fonts.primary,
    color: 'blackAlpha.950',
    letterSpacing: pxToRem(1),
    lineHeight: [pxToRem(18), pxToRem(18), pxToRem(18), pxToRem(18)]
}

export const labelInputStyle = {
    border: `${pxToRem(1)} solid ${colors.cav_light_black}`,
    borderRadius: '0px',
    height: pxToRem(44),
    padding: `0 ${pxToRem(15)}`,
    width: '100%',
    letterSpacing: pxToRem(1)
}

export const errorMessageStyle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(12),
    fontWeight: '700',
    letterSpacing: pxToRem(1),
    lineHeight: pxToRem(18),
    margin: `${pxToRem(8)} 0 ${pxToRem(16)}`,
    color: 'cav_dark_red'
}

export const balanceButtonStyle = {
    marginTop: pxToRem(10),
    backgroundColor: 'cav_dark_red',
    borderRadius: '0px',
    color: 'white',
    fontSize: pxToRem(14),
    fontWeight: '700',
    fontFamily: fonts.primary,
    padding: `${pxToRem(12.6)} ${pxToRem(42)}`,
    textTransform: 'uppercase',
    letterSpacing: pxToRem(1),
    width: '100%',
    lineHeight: pxToRem(18),
    '&:hover': {
        textDecoration: 'none'
    }
}

export const labelStarStyle = {
    color: 'red.950',
    display: 'inline'
}
